import { Chip, Grid, InputAdornment, TextField } from "@material-ui/core"
import { SearchIcon } from "lucide-react"
import React from "react"
import useStyles from "../styles"

const FiltroNovaConversa = ({ setSearchParam, searchParam, chipFilter, setChipFilter }) => {
  const classes = useStyles()
  return (
    <Grid item xs={12}>
      <div className={classes.barraDePesquisa}>
        <TextField
          className={classes.searchInput}
          variant="standard"
          placeholder="Pesquisar conversas e mensagens"
          fullWidth
          value={searchParam}
          onChange={(e) => setSearchParam(e.target.value)}
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon strokeWidth={1.6} size={"24px"} className={classes.searchIcon} />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={classes.chipContainer}>
        <Chip
          label={<div className={classes.chipLabel}>Todos</div>}
          onClick={() => setChipFilter(0)}
          className={`${classes.chip} ${chipFilter === 0 ? classes.chipSelecionado : classes.chipDefault}`}
        />

        <Chip
          label={<div className={classes.chipLabel}>Whatsapp</div>}
          onClick={() => setChipFilter(2)}
          className={`${classes.chip} ${chipFilter === 2 ? classes.chipSelecionado : classes.chipDefault}`}
        />
        <Chip
          label={<div className={classes.chipLabel}>Chat interno</div>}
          onClick={() => setChipFilter(1)}
          className={`${classes.chip} ${chipFilter === 1 ? classes.chipSelecionado : classes.chipDefault}`}
        />
      </div>
    </Grid>
  )
}

export default FiltroNovaConversa
